<template>
  <section class="document-form sme-container__info sme-container__info-document">
    <div class="box">
      <div class="table">
        <div class="th font-14" >Documents</div>
        <div class="form-item tr">
          <span  v-if="formData.cust_typ == 2">Business Registration Certification</span>
          <span v-else>Policyholder HKID</span>
          <file-container
            is-show-detail
            is-viewer
            :fileData="formData.id_type_pic" />
        </div>
        <div
          v-if="formData.cust_typ == 2"
          class="form-item tr">
          <span>Business Registration Certificate</span>
          <file-container
            is-viewer
            :fileData="formData.br_pic" />
        </div>

        <template v-if="hasBenefitsEmployees">
          <div
            v-if="formData.domestic_helper_info && formData.domestic_helper_info.length > 0"
            class="tr">
            Domestic Helper Information
          </div>
          <div
            v-for="(item, index) in formData.domestic_helper_info"
            :key="index"
          >
            <span class="tr">Domestic Helper {{ index+1 }}</span>
            <div class="tr form-item">
              <span class="label">HKID / Passport</span>
              <file-container
                is-viewer
                is-show-detail
                :fileData="formData.domestic_helper_info[index].id_type_pic" />
            </div>
          </div>
        </template>
        <template v-if="hasBenefitsPets">
          <div
            v-if="formData.pet_info && formData.pet_info.length > 0"
            class="tr">
            Pet Information
          </div>
          <div
            v-for="(item, index) in formData.pet_info"
            :key="index"
          >
            <div class="tr">Pet {{ index+1 }}</div>
            <div class="tr form-item">
              <span class="label">Microchip Copy</span>
              <file-container
                is-viewer
                is-show-detail
                :fileData="formData.pet_info[index].microchip_copy_pic" />
            </div>
          </div>
        </template>

        <div
          v-if="formData.other_file && formData.other_file.length > 0"
          class="form-item">
          <div class="tr">Additional Documents</div>
          <div class="tr form-item">
            <file-container
              v-for="(item, index) in formData.other_file"
              :key="index"
              is-viewer
              is-show-detail
              :fileData="item"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'HomefireDocumentInfo',
  props: {
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    hasBenefitsEmployees() {
      const { benefits = [] } = this.formData
      if(benefits && benefits.includes(1)) {
        return true
      }
      return false
    },
    hasBenefitsPets() {
      const { benefits = [] } = this.formData
      if(benefits && benefits.includes(4)) {
        return true
      }
      return false
    },
  }
}
</script>
<style lang="scss" scoped>
@import "../../../quoting/sme/info";
.document-table{
  .tr:last-child{
    border-bottom-left-radius: 0px!important;
    border-bottom-right-radius: 0px!important;
  }
}

</style>
